function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.28 7.6V.96h19.44V7.6z",
  fill: "currentColor"
});

function SvgIconMinus(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 8"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMjUuMjggNDQuNnYtNi42NGgxOS40NHY2LjY0eiIgZmlsbD0iY3VycmVudENvbG9yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjUgLTM3KSIvPjwvc3ZnPgo=";
export { SvgIconMinus as ReactComponent };